import { resolveImg } from "@/lib/api";

export function Logo({ size = "md", logoUrl = "", light = false }) {
  const sizes = {
    sm: { title: "text-lg", bar: "w-8 h-[3px]", tag: "text-[7px]" },
    md: { title: "text-2xl", bar: "w-12 h-1", tag: "text-[9px]" },
    lg: { title: "text-4xl", bar: "w-16 h-1.5", tag: "text-[11px]" },
  };
  const s = sizes[size] || sizes.md;

  if (logoUrl) {
    return <img src={resolveImg(logoUrl)} alt="Konzade" className={size === "lg" ? "h-16" : size === "sm" ? "h-8" : "h-11"} data-testid="brand-logo-img" />;
  }

  return (
    <div className="inline-flex flex-col leading-none" data-testid="brand-logo">
      <span className={`font-heading font-black tracking-tight ${s.title} ${light ? "text-white" : "text-black"}`}>
        KONZADE
      </span>
      <span className={`${s.bar} bg-rose-600 my-1`} />
      <span className={`font-heading font-bold tracking-[0.3em] ${s.tag} ${light ? "text-gray-300" : "text-slate-500"}`}>
        ENDÜSTRİYEL MUTFAK
      </span>
    </div>
  );
}
